/** 無需登入即可瀏覽的路徑，App.tsx 和 Sidebar.tsx 共用 */
export const PUBLIC_PATHS = [
  '/', '/enterprise', '/store', '/custom-service', '/apps', '/games', '/board', '/wishlist',
  // 各系統方案與價格、服務條款、隱私權、退款政策：要公開（綠界審核要看得到價格與政策；主流 SaaS 的價格頁也不用登入）
  '/crm', '/accounting', '/pm', '/hr', '/booking', '/queue', '/terms', '/privacy', '/refund-policy', '/contact',
];

/** Identity Service URL，所有認證相關操作共用 */
export const IDENTITY_SERVICE_URL = process.env.REACT_APP_IDENTITY_SERVICE_URL || 'http://localhost:3000';
